import { Card } from '@nextui-org/react'
import { FC, HTMLProps } from 'react'
import { useSelectTankStore } from '../../store/selectTank/useSelectTankStore'
import TankChip from './TankChip'

export const TankSelected: FC<HTMLProps<HTMLDivElement>> = ({ ...props }) => {
  const { selectedTankList, detach } = useSelectTankStore()

  return (
    <div
      data-testid="tank-selected-container"
      className="overflow-x-hidden w-full max-w-full flex-shrink-0"
    >
      <p className="text-tdplindigo overflow-x-hidden" data-testid="selected-tanks-label">
        Selected Tanks
      </p>
      <Card
        className="border border-tdpldarkgrey border-opacity-60 w-full overflow-x-hidden"
        radius="md"
        shadow="sm"
        data-testid="selected-tanks-card"
      >
        <div
          className="flex flex-row flex-wrap justify-start p-1 min-h-[3rem] max-h-[10rem] overflow-y-auto"
          style={{ touchAction: 'pan-y', WebkitOverflowScrolling: 'touch' }}
          onTouchStart={(e) => e.stopPropagation()}
        >
          {selectedTankList?.map((tankSelected, index) => (
            <TankChip
              key={index}
              submitTank={tankSelected}
              isActivated={false}
              onTankChipClick={() => detach(tankSelected.tankId)}
              data-testid={`selected-tank-chip-${tankSelected.tankName}`}
            />
          ))}
          {selectedTankList.length === 0 && (
            <div
              className="flex items-center justify-center text-gray-500 text-sm min-h-[2rem] w-full"
              data-testid="no-tanks-selected-placeholder"
            >
              No tanks selected
            </div>
          )}
        </div>
      </Card>
    </div>
  )
}

export default TankSelected
